var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNoDataIllustration = function SvgNoDataIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.963 3l18 18m-12-16h9a3 3 0 013 3v8c0 .295-.043.588-.128.87m-2.002 2.002a2.999 2.999 0 01-.87.128h-12a3 3 0 01-3-3V8a3 3 0 012.124-2.87M3.963 11h8m4 0h6m-14 4h.01m3.99 0h2",
    stroke: "#6E7D8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNoDataIllustration;